import { Box, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/Pending";

interface StatusIconProps {
  status: string;
  size?: "small" | "medium" | "large";
}

export const StatusIcon = ({ status, size = "small" }: StatusIconProps) => {
  const theme = useTheme();

  const getStatusIcon = () => {
    switch (status) {
      case "approved":
        return <CheckCircleIcon fontSize={size} />;
      case "rejected":
      case "failed":
        return <CancelIcon fontSize={size} />;
      case "pending":
      default:
        return <PendingIcon fontSize={size} />;
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case "approved":
        return theme.palette.success.main;
      case "rejected":
      case "failed":
        return theme.palette.error.main;
      case "pending":
      default:
        return theme.palette.warning.main;
    }
  };

  return (
    <Box
      sx={{
        color: getStatusColor(),
        backgroundColor: "white",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {getStatusIcon()}
    </Box>
  );
};
